import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Phone, MessageCircle, ArrowUp } from 'lucide-react';
import { FLOAT } from '@/constants/testIds';

const PHONE = '+19843779835';
const WHATSAPP = `https://wa.me/19843779835?text=${encodeURIComponent("Hi Trendy Closet, I'd love to know more about your collection.")}`;

export const FloatingActions = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col gap-3 items-end">
      <a
        href={WHATSAPP}
        target="_blank"
        rel="noreferrer"
        data-testid={FLOAT.whatsapp}
        aria-label="Chat on WhatsApp"
        className="group flex items-center gap-3 bg-[#25D366] text-white shadow-card hover:shadow-xl rounded-full pl-4 pr-5 py-3 transition-all duration-500 animate-float"
      >
        <MessageCircle className="w-5 h-5" />
        <span className="hidden sm:inline text-xs uppercase tracking-[0.18em] font-medium">WhatsApp</span>
      </a>
      <a
        href={`tel:${PHONE}`}
        data-testid={FLOAT.call}
        aria-label="Call now"
        className="flex items-center gap-3 bg-burgundy text-ivory shadow-card hover:shadow-xl rounded-full pl-4 pr-5 py-3 transition-all duration-500"
      >
        <Phone className="w-5 h-5" />
        <span className="hidden sm:inline text-xs uppercase tracking-[0.18em] font-medium">Call Now</span>
      </a>
      <AnimatePresence>
        {show && (
          <motion.button
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            data-testid={FLOAT.top}
            aria-label="Back to top"
            className="w-11 h-11 bg-ivory border border-brandborder text-charcoal hover:bg-gold hover:text-ivory hover:border-gold rounded-full flex items-center justify-center shadow-luxe transition-all duration-500"
          >
            <ArrowUp className="w-4 h-4" />
          </motion.button>
        )}
      </AnimatePresence>
    </div>
  );
};

export default FloatingActions;
